
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsComponent } from '@vg-constellation/angular-19/details';
import { StepIndicatorComponent as ConstellationStepIndicatorComponent } from '@vg-constellation/angular-19/step-indicator';

@Component({
  selector: 'app-step-indicator',
  templateUrl: './step-indicator.component.html',
  imports: [
    CommonModule,
    DetailsComponent,
    ConstellationStepIndicatorComponent,
  ],
  styleUrls: ['./step-indicator.component.scss'],
})
export class StepIndicatorComponent {
  @Input() stepLabels: string[] = [
    'Select recipient',
    'Review & submit',
    'Confirmation'
  ];
  @Input() currentStep: number = 1;
  @Input() isSmallScreen!: boolean;
}
